import React, { useState } from "react";
import PropTypes from "prop-types";
import { Title, Fieldset, Button, Control, Field } from "rbx";
import { useMutation } from "react-apollo";

import { CREATE_VENDOR_MUTATION } from "../../graphql/Vendors/Vendors.graphql";
import { getUTCFormattedDate, ourToast as toast } from "../../utils";
import VendorForm from "./VendorForm";

const DEFAULT_STATE = {
  Name: "",
  Active: true,
  Address1: "",
  Address2: "",
  City: "",
  State: "",
  Zip: "",
  Contact: "",
  Telephone: "",
  Fax: "",
  EmailAddr: "",
  WebSite: "",
  LastTransactionDate: ""
};

const AddVendor = ({ onComplete }) => {
  const [inputs, setInputs] = useState({ ...DEFAULT_STATE });
  const handleChange = e => {
    const value =
      e.target.type === "checkbox" ? e.target.checked : e.target.value;
    setInputs({ ...inputs, [e.target.name]: value });
  };
  const [createVendor, { loading }] = useMutation(CREATE_VENDOR_MUTATION, {
    refetchQueries: ["ALL_VENDORS_QUERY"]
  });
  const handleSave = async e => {
    e.preventDefault();
    try {
      console.log(inputs);

      await createVendor({
        variables: {
          data: {
            ...inputs,
            LastTransactionDate: inputs.LastTransactionDate
              ? getUTCFormattedDate(inputs.LastTransactionDate)
              : null
          }
        }
      });
      toast.success("Vendor created successfully.");
      onComplete();
    } catch (err) {
      toast.error("Error creating Vendor.");
    }
  };
  return (
    <form
      className="add-vendor-form"
      id="add-vendor-form"
      onSubmit={handleSave}
    >
      <Title>Create Vendor</Title>
      <Fieldset disabled={loading}>
        <VendorForm inputs={inputs} onChange={handleChange} />
        <hr />
        <Field kind="group">
          <Control>
            <Button color="primary" form="add-vendor-form" type="submit">
              Submit
            </Button>
          </Control>
          <Control>
            <Button type="button" onClick={onComplete}>
              Cancel
            </Button>
          </Control>
        </Field>
      </Fieldset>
    </form>
  );
};

AddVendor.propTypes = {
  onComplete: PropTypes.func
};
export default AddVendor;
